/*eslint-disable import/default */
import React from 'react';
import { render } from 'react-dom';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './components/App/App';
import HomePage from './components/HomePage/HomePage';
import PipelinePage from './components/PipelinePage/PipelinePage';
import PortfolioPage from './components/PortfolioPage/PortfolioPage';
import NewSubmissionPage from './components/NewSubmissionPage/NewSubmissionPage';
import RenewalSubmissionPage from './components/RenewalSubmissionPage/RenewalSubmissionPage';
import StipsPage from './components/StipsPage/StipsPage';
import LogoutPage from './components/LogoutPage/LogoutPage';
import PageNotFoundPage from './components/PageNotFoundPage/PageNotFoundPage';
import ShortenedNewSubmissionPage from './components/ShortenedNewSubmissionPage/ShortenedNewSubmissionPage';
import { setMixPanelToken } from '@forwardfinancing/analytics-frontend-library';
import { datadogRum } from '@datadog/browser-rum';
import {
  APP_VERSION,
  DATADOG_RUM_APPLICATION_ID,
  DATADOG_RUM_CLIENT_TOKEN,
  DATADOG_SITE,
  DEPLOY_ENV,
  MIXPANEL_API_TOKEN,
} from './constants/global';
import './styles/styles.css';

/* global __webpack_public_path__: writable */
// The funding app (Rails) renders our HTML at app.<env>.forwardfinancing.com/portal/*, but
// injects main.js from PARTNER_PORTAL_FE — partner-portal.<env>.forwardfinancing.com/portal/.
// Webpack's publicPath is empty, so lazily-imported chunks (Datadog's session replay recorder,
// pdf.js) resolve relative to the document and get refused on the Rails host. Point publicPath
// at whichever host actually served main.js, before datadogRum.init() below triggers the
// recorder import.
//
// Do NOT swap this for CRA's PUBLIC_URL: that also rewrites asset-manifest.json to absolute
// URLs, which base_controller.rb File.joins onto PARTNER_PORTAL_FE, doubling the URL so that
// main.js stops loading at all.
const mainScriptRegex = /\/static\/js\/[^/]*$/;
// currentScript is the tag executing us, so it is exact; the rest of the list is a fallback for
// contexts where it is null (jsdom, module scripts).
const mainScript = [document.currentScript]
  .concat(Array.from(document.getElementsByTagName('script')))
  .find((script) => script && mainScriptRegex.test(script.src));

if (mainScript) {
  // Replace with '/', not '', to keep the separator webpack expects before 'static/js/...'.
  __webpack_public_path__ = mainScript.src.replace(mainScriptRegex, '/');
}

const store = configureStore();


setMixPanelToken(MIXPANEL_API_TOKEN());

datadogRum.init({
  applicationId: DATADOG_RUM_APPLICATION_ID(),
  clientToken: DATADOG_RUM_CLIENT_TOKEN(),
  site: DATADOG_SITE(),
  service: 'partner_portal',
  env: DEPLOY_ENV(),
  version: APP_VERSION(),
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  enablePrivacyForActionName: true,
  defaultPrivacyLevel: 'mask-user-input',
});

render(
  <Provider store={store}>
    <BrowserRouter>
      <App>
        <div>
          <Switch>
            <Route exact path="/portal" component={HomePage} />
            <Route path="/portal/pipeline" component={PipelinePage} />
            <Route path="/portal/portfolio" component={PortfolioPage} />
            <Route path="/portal/new_submission" component={NewSubmissionPage} />
            <Route path="/portal/shortened_submission" component={ShortenedNewSubmissionPage} />
            <Route path="/portal/renewal_submission" component={RenewalSubmissionPage} />
            <Route path="/portal/shortened_submission" component={ShortenedNewSubmissionPage} />
            <Route path="/portal/stipulations" component={StipsPage} />
            <Route path="/portal/sign_out" component={LogoutPage} />
            <Route path="*" component={PageNotFoundPage} />
          </Switch>
        </div>
      </App>
    </BrowserRouter>
  </Provider>,
  document.getElementById('app')
);
